<template>
    <div>
        <div class="card mb-5">
            <div class="card-body p-0">
                <div class="row">
                    <div class="col-md-4 col-sm-12 col-12" style="text-align:center;">
                        <div class="dropdown dropdown-styled">
                            <button class="btn btn-primary dropdown-toggle btn-block" type="button"
                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                {{ __('redeem.category') }}
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a v-for="(category, c_index) in categories" :key="c_index" class="dropdown-item"
                                   :href="'#prod_cat_id-'+category.prod_cat_id">{{ category.category_name }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12" style="text-align:center;">
                        <a href="#modal-deliveryinfo" class="info-link delivery_preview" data-toggle="modal"
                           data-target="#modal-deliveryinfo">
                            <img alt="" src="/_images/delivery.svg" style="width:38px; padding-right:10px;"><span
                            id="modallabel-deliveryinfo">{{ __('redeem.delivery_text') }}</span>
                        </a>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12"
                         style="text-align:center;">
                        <a href="#modal-faq" class="info-link delivery_preview" data-toggle="modal"
                           data-target="#modal-faq">
                            <img alt="" src="/_images/info.svg" style="width:32px; padding-right:10px;"><span
                            id="modallabel-faq">{{ __('redeem.delivery_faq') }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="busy_loading" class="text-center">
            <div class="spinner-border" role="status"></div>
            <div>Loading...</div>
        </div>
        <div v-else-if="categories.length" v-for="(category, c_index) in categories" :key="c_index">
            <product-category :id="'prod_cat_id-'+category.prod_cat_id" :category="category" :testmode="testmode"
                              :order="order" :points="points" :points-left="pointsLeft"></product-category>
        </div>
        <div v-else style="display: none;">
            <div class="alert alert-danger">Failed to load products</div>
        </div>

        <div class="modal fade" id="modal-deliveryinfo" tabindex="-1" role="dialog"
             aria-labelledby="modallabel-deliveryinfo" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document" style="max-width: 650px;">
                <div class="modal-content">
                    <div style="background-image: url('/_images/delivery-popup.jpg'); background-repeat: no-repeat; background-size: cover; height: 550px;">
                        <button type="button" class="close" data-dismiss="modal" :aria-label="__('redeem.close')"
                                style="color: #fff; padding: 10px 20px; font-size: 50px; font-weight: 300;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot name="modaldeliveryinfo"></slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal-faq" tabindex="-1" role="dialog" aria-labelledby="modallabel-faq"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document" style="max-width: 650px;">
                <div class="modal-content">
                    <div style="background-image: url('/_images/delivery-popup.jpg'); background-repeat: no-repeat; background-size: cover; height: 550px;">
                        <button type="button" class="close" data-dismiss="modal" :aria-label="__('redeem.close')"
                                style="color: #fff; padding: 10px 20px; font-size: 50px; font-weight: 300;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body p-0">
                        <slot name="modalfaq"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { orderBy } from 'lodash';

export default {
    props: {
        points: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Boolean,
            default: false,
        },
        pointsLeft: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        is_redeemed: 0,
        is_testmode: 0,
        testmode: null,
        categories: [],
    }),
    mounted() {
        this.getProducts();
    },
    methods: {
        isRedeemed() {
            return this.is_redeemed;
        },
        getProducts() {
            const self = this;
            this.busy_loading = true;

            axios.get('/vue/' + this.__('redeem.current_langcode') + '/card/session')
                .then((response) => {
                    if (response.status === 200) {
                        self.is_redeemed = response.data.card.is_redeemed;
                        self.is_testmode = response.data.card.TESTMODE;
                        self.card_uid = response.data.card.card_uid;

                        if (self.card_uid.includes('WWW')) {
                            self.testmode = 'WWW';
                        }

                        if (self.card_uid.includes('TOT')) {
                            self.testmode = 'TOT';
                        }

                        if (self.card_uid.includes('PRO')) {
                            self.testmode = 'PRO';
                        }
                    }
                }).finally(() => {
                    axios.get('/vue/' + this.__('redeem.current_langcode') + '/get_categories_products?order=' + (this.order ? 1 : 0) + '&' + self.card_uid)
                        .then((response) => {
                            const cat = response.data.categories.map((subcat) => {
                                // eslint-disable-next-line no-param-reassign
                                if (self.points) {
                                    // eslint-disable-next-line no-param-reassign
                                    subcat.products = subcat.products.map((product) => {
                                        if (self.points && !(self.pointsLeft >= product.points)) {
                                            // eslint-disable-next-line no-param-reassign
                                            product.sort_no = 1000000;
                                        } else {
                                            // eslint-disable-next-line no-param-reassign
                                            product.sort_no = 1;
                                        }
                                        return product;
                                    });
                                }

                                // eslint-disable-next-line no-param-reassign
                                subcat.products = subcat.products.filter((product) => {
                                    if (self.is_testmode) {
                                        return true;
                                    }

                                    if (!self.is_redeemed) {
                                        return true;
                                    }

                                    return self.is_redeemed && !product.out_of_stock;
                                });

                                if (self.points) {
                                    // eslint-disable-next-line no-param-reassign
                                    subcat.products = orderBy(subcat.products, 'sort_no', 'asc');
                                }
                                return subcat;
                            });
                            Vue.set(self, 'categories', cat);
                        })
                        .finally(() => {
                            Vue.set(self, 'busy_loading', false);
                        });
                });
        },
    },
};
</script>
